import React from 'react';
import { View, Image } from 'react-native';

import { pc_money } from '../../../assets/icons';
import { AppHeader } from '../../../components/common';
import { GreenButton } from '../../../components/derivative';
import { AppText, AppButton } from '../../../components/form';
import styles from './styles';

const ClaimSuccess = ({ navigation, route }) => {
    return (
        <View style={styles.viewBase}>
            <AppHeader title={`Resgate com Sucesso`} navigation={navigation} />
            <View style={styles.content}>
                <Image source={pc_money} style={styles.imageCoinBank} />
                <AppText size='bold' style={styles.textClaimSuccess}>{`${route.params.coins} moedas foram resgatadas com sucesso!`}</AppText>
                <GreenButton label={'VOLTAR'} onPress={()=>navigation.navigate('Worker Coin Bank')} />
            </View>
        </View>
    )
}

export default ClaimSuccess;